// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__21wG1","header":"ClearentDisclaimer_header__14KO3","inner":"ClearentDisclaimer_inner__1SBJn"};